import LangEnum from '../../lang/LangEnum';
import { CatalogSectionSortCriterionEnum } from './enums/catalogSectionSortCriterion.enum';

export const SECTION_SORT_CRITERION_LANG: Record<CatalogSectionSortCriterionEnum, LangEnum> = {
  [CatalogSectionSortCriterionEnum.MANUAL]: LangEnum.CATALOGS_CATALOG_SECTION_SORT_CRITERION_MANUAL,
  [CatalogSectionSortCriterionEnum.NAME]: LangEnum.CATALOGS_CATALOG_SECTION_SORT_CRITERION_NAME,
  [CatalogSectionSortCriterionEnum.CODE]: LangEnum.CATALOGS_CATALOG_SECTION_SORT_CRITERION_CODE,
  [CatalogSectionSortCriterionEnum.REFERENCE_CODE]:
    LangEnum.CATALOGS_CATALOG_SECTION_SORT_CRITERION_REFERENCE_CODE,
  [CatalogSectionSortCriterionEnum.CLASSIFICATION_TYPE]:
    LangEnum.CATALOGS_CATALOG_SECTION_SORT_CRITERION_CLASSIFICATION,
};
